import { Link } from "react-router-dom";

//added to make it easier to switch between different dealers when testing locally
const dealer = "braustin";

/** @param {string} str */
const withUserBase = (str) => ({
  url: `/${dealer}/application/app_XXXXXXXXXXXX/borrower/bor_YYYYYYYYYYYY/${str}`,
  label: str,
});
const links = [
  { url: `/${dealer}/dev/auth`, label: "auth (test signin/register)" },
  { url: `/${dealer}/login`, label: "login" },
  { url: `/${dealer}/login/email-sent`, label: "login/email-sent" },
  { url: `/${dealer}/login/sms-sent`, label: "login/sms-sent" },
  { url: `/${dealer}/register`, label: "register" },
  { url: `/${dealer}-test`, label: "docusign-test" },
  {
    url: `/${dealer}/application/app_XXXXXXXXXXXX/progress`,
    label: "progress",
  },
  {
    url: `/${dealer}/application/app_XXXXXXXXXXXX/signature`,
    label: "signature",
  },
  withUserBase("personal-info"),
  withUserBase("personal-info/citizenship"),
  withUserBase("personal-info/marital-status"),
  withUserBase("personal-info/dependents"),
  withUserBase("address"),
  withUserBase("address/coborrower-confirmation"),
  withUserBase("employment"),
  withUserBase("income"),
  withUserBase("financial-accounts"),
  withUserBase("expenses"),
  withUserBase("expenses/bankruptcy"),
  withUserBase("home"),
  withUserBase("home/placement"),
  withUserBase("land"),
  withUserBase("home/manufacture-detail"),
  withUserBase("home/down-payment"),
  withUserBase("ethnicity"),
  withUserBase("ethnicity/race"),
  withUserBase("ethnicity/sex"),
  withUserBase("overview"),
  withUserBase("final-steps/consent"),
  withUserBase("final-steps/sales-person"),
  withUserBase("final-steps/coborrower"),
  withUserBase("final-steps/coborrower/invite"),
];
export default () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "900px",
        margin: "0 auto",
      }}
    >
      <h2>Landing Page</h2>
      <br />
      <ul style={{ listStyle: "inside" }}>
        {links.map(({ url, label }) => (
          <li key={url} style={{ margin: "5px" }}>
            <Link target="_blank" to={url}>
              /{label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
